import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';  
import { Subject }    from 'rxjs';
@Injectable()
export class GlobalsService 
{
    
  
    static parcele_layer_id: any = 49;
    static hs_layer_id: any = 47;
    static javne_stavbe_layer_id: any = 3;
    static javne_stavbe_mol_layer_id: any = 326;

    static fotovoltaika_potencialno_primerna_obmocja: any = 246;
    static fotovoltaika_izbrana_obmocja: any = 247;
    
    static fotovoltaika_objekti_samooskrba: any = 265;
    static fotovoltaika_objekti_proizvodnja: any = 264;
    static fotovoltaika_primerni_objekti: any = 263;

    static  sv_url: string = "https://www.google.com/maps/embed/v1/streetview?key=AIzaSyA8M9J9cAhObNBjbA5uMLIiL35SqSSqbXs&location=";
    static  s3d_url: string = "https://www.google.com/maps/embed/v1/view?key=AIzaSyA8M9J9cAhObNBjbA5uMLIiL35SqSSqbXs&maptype=satellite&zoom=18&location=";
    static mm_url_proxy: string = "https://www.monolitmap.si/wms.php?lock=katarinaS98765hhkldsw66654ksdkjk";

    static rest_url: string = "";

    static gs_url: string = "/geoserver"; 

    static atlas_base_url: string = '';
    static keycloak_logouturl: string = ''; 
    static keycloak_url: string = '';

    static typesense_api_url: string = '';

  constructor() 
  { 
      
  }

  
  public initConfig(): Observable<boolean> {
    console.log('initConfig START');

    const s = new Subject<boolean>();

    fetch('/assets/settings.json', { method: 'get' })
        .then((response) => {
        console.log('settings fetch response', response.ok, response.url);

        if (!response.ok) {
            console.error('settings fetch failed', response.status, response.statusText);
            s.next(false);
            s.complete();
            return;
        }

        response.json()
            .then((d: any) => {
            console.log('settings json loaded', d);
            console.log('typesense_api_url from json', d.typesense_api_url);

            GlobalsService.typesense_api_url = d.typesense_api_url;

            console.log('assigned GlobalsService.typesense_api_url', GlobalsService.typesense_api_url);

            s.next(true);
            s.complete();
            })
            .catch((err) => {
            console.error('json parse error', err);
            s.next(false);
            s.complete();
            });
        })
        .catch((err) => {
        console.error('fetch error', err);
        s.next(false);
        s.complete();
        });

    return s.asObservable();
    }

  public static getAtlasBaseUrl(): string {
    return GlobalsService.atlas_base_url;
  }

  public static getKeycloakOG(): string {
    return GlobalsService.keycloak_url;
  }


  public static getTypesenseApiUrl(): string {
    console.log('getTypesenseApiUrl called, current value =', GlobalsService.typesense_api_url);

    if (!GlobalsService.typesense_api_url) {
        throw new Error('typesense_api_url is not loaded from settings.json');
    }
    return GlobalsService.typesense_api_url;
    }

  public getKcUrl():string
  {
      return GlobalsService.keycloak_url;
  }
  
  public getParceleLayerId()
  {
      return GlobalsService.parcele_layer_id; 
  }
  
  public getHsLayerId()
  {
      return GlobalsService.hs_layer_id;
  }
  
  public getJavneStavbeLayerId()
  {
      return GlobalsService.javne_stavbe_layer_id;
  }

  public getJavneStavbeMolLayerId()
  {
      return GlobalsService.javne_stavbe_mol_layer_id;
  }
  
  public getFotovoltaikaPPOId()
  {
      return GlobalsService.fotovoltaika_potencialno_primerna_obmocja; 
  }

  public getFotovoltaikaIOId()
  {
      return GlobalsService.fotovoltaika_izbrana_obmocja; 
  }


  public getFotovoltaikaFOSId()
  {
      return GlobalsService.fotovoltaika_objekti_samooskrba; 
  }

  public getFotovoltaikaFOPId()
  {
      return GlobalsService.fotovoltaika_objekti_proizvodnja; 
  }

  public getFotovoltaikFPOId()
  {
      return GlobalsService.fotovoltaika_primerni_objekti; 
  }

  public static getKeyCloakLogoutUrl():string
  {
      return GlobalsService.keycloak_logouturl;
  }
  
  public getRestUrl():string
  {
      //console.log(GlobalsService.rest_url);
      return GlobalsService.rest_url;
  }
  
  public getKartoGeoserverUrl():string
  {
      return GlobalsService.gs_url;
  }
  
  public getStreetViewUrl():string
  {
      return GlobalsService.sv_url;
  }
  
//   public getMonolitMapProxyWmsUrl():string
//   {
//       return GlobalsService.mm_url_proxy;
//   }
}
